import { Plus } from "lucide-react";
import { TextBody } from "../info/TextBody";

// Uitklapbare vragen uit het centrale FAQ-beheer; antwoorden ondersteunen [label](/pad)-links.
export const FaqItems = ({ faqs, testid = "faq-item" }) => (
  <div className="divide-y divide-slate-200 border-y border-slate-200">
    {faqs.map((f, i) => (
      <details key={f.id || f.question} className="faq-item group" data-testid={`${testid}-${i}`}>
        <summary className="flex cursor-pointer list-none items-center justify-between gap-6 py-5 text-[16px] font-semibold text-ink hover:text-maas sm:text-[17px]">
          <h3 className="font-sans text-[inherit] font-semibold leading-snug tracking-normal">{f.question}</h3>
          <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full ring-1 ring-slate-200 transition-transform duration-200 group-open:rotate-45">
            <Plus className="h-4 w-4 text-maas" aria-hidden="true" />
          </span>
        </summary>
        <TextBody text={f.answer} className="pb-6 pr-4 sm:pr-12" />
      </details>
    ))}
  </div>
);
